import React from "react";
import { TextInput, View, StyleSheet } from "react-native";
import Label from "../Label";

const TextArea = ({ value, onSubmit, formItem = {} }) => {
  const { label } = formItem;
  return (
    <>
      <Label label={label} />
      <View style={styles.textInputContainer}>
        <TextInput
          value={value}
          placeholder="यहाँ लिखें..."
          multiline
          // numberOfLines={5}
          onChangeText={onSubmit}
          style={styles.textArea}
        />
      </View>
    </>
  );
};

export default TextArea;

const styles = StyleSheet.create({
  textInputContainer: {
    borderWidth: 1,
    borderRadius: 6,
    borderColor: "rgba(0, 0, 0, 0.2)",
    backgroundColor: "white",
    padding: 15,
  },
  textArea: {
    fontFamily: "NotoSansDevanagari-Regular",
    fontSize: 14,
    lineHeight: 22,
    minHeight: 140,
    justifyContent: "flex-start",
    textAlignVertical: "top",
  },
});
